// Hand a coordinate off to whatever navigation app the device has.
//
// There is no single URL scheme that works everywhere. `geo:` is the standard
// and Android resolves it into its app chooser, but iOS does not register it —
// Safari silently leaves the link dead, which is the worst outcome because it
// looks fine right up until someone taps it in the street. Apple devices get an
// Apple Maps https-URL instead, which opens the native app.
//
// Callers should keep a copy-to-clipboard affordance alongside: it is the only
// thing guaranteed to work on desktop and in locked-down browsers.

export function navigationHref(lat: number, lng: number, label?: string): string {
  const isApple =
    typeof navigator !== 'undefined' &&
    /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent);

  if (isApple) {
    const q = label ? `&q=${encodeURIComponent(label)}` : '';
    return `https://maps.apple.com/?ll=${lat},${lng}${q}`;
  }

  const pin = label ? `(${encodeURIComponent(label)})` : '';
  return `geo:${lat},${lng}?q=${lat},${lng}${pin}`;
}
